// extracted by mini-css-extract-plugin
export default {"wrapper":"CodeBlockView_wrapper__n0swu","toolbar":"CodeBlockView_toolbar__s-Mc+","langSelect":"CodeBlockView_langSelect__K4-s1","pre":"CodeBlockView_pre__emldO"};